import { useState } from "react";
import {
  signupAPI,
} from "../../services/allAPI";

export const useSignup = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  

  const register = async (payload) => {
    try {
      setLoading(true);
      setError("");
      return await signupAPI(payload);
    } catch (err) {
      setError(
        err?.response?.data?.email ||
        err?.response?.data?.detail ||
        "Registration failed"
      );
      throw err;
    } finally {
      setLoading(false);
    }
  };

  

  return {
    register,
    loading,
    error,
  };
};
